interface BedVariationType {
  bed_type_value?: string | null
}

export function isBedOptionAllowed(variation: BedVariationType | null | undefined, option: string): boolean {
  if (variation?.bed_type_value !== 'reversible') return true
  return option === 'textile' || option === 'textiles' || option === 'topper' || option === 'toppers'
}

export function isBedViewAllowed(variation: BedVariationType | null | undefined, view: string | null): boolean {
  return view === null || view === 'overview' || isBedOptionAllowed(variation, view)
}

// Apply to both saved configurations and render-ready state, preserving textiles and toppers.
export function restrictBedOptions<T extends object>(variation: BedVariationType | null | undefined, config: T): T {
  if (variation?.bed_type_value !== 'reversible') return config
  return {
    ...config,
    legs: null,
    headboard: null,
    bedsideTable: null,
    ottoman: null,
    accessories: [],
  }
}
